import { Box, ColorOptions, ModBox, Text, TextNew } from '@jfs/ui-new'
import { ButtonNew } from '../AdminButton'
import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import { FlatList } from 'react-native'
import { ListHead } from '../ListHead'
import { ListRow } from '../ListRow'
import { Pagination } from '../Pagination'
import { SearchFilter } from '../SearchFilter'
import { styles } from './styles'

interface ListProps {
  type?: string
  data: Array<any>
  numOfColumns?: number
  sizeConfig?: Array<number>
  headTitle: any
  keyExtractor: any
  listTitle?: string
  onPress?: (item: any, index: number) => void
  onAction?: (item: any, index: number) => void
  onEdit?: (item?: any) => void
  onDelete?: (item?: any) => void
  onSearch?: any
  filterData?: any
  expandView?: any
  isExpanded?: boolean
  showExpandArrow?: boolean
  expandedIndex?: number
  showSyncPam?: boolean
  onSync?: () => void
  hrefPath?: string
  isColumnSearchEnabled?: boolean
  onSearchTextChange?: any
  isActionLoading?: boolean
  loadingIndex?: number
  hidePagination?: boolean
  exportFile?: any
  getFilteredData?: any
  onChecked?: (isChecked, index) => void
  onAllChecked?: (isAllChecked) => void
  isAllChecked?: boolean
  pageSizeFromApi?: number
  updateSortKeys?: any
  sortOrder?: any
  columnsWidth?: any
  tableWidth?: number
  hideTitle?: boolean
  renderItem?: any
  cellTextStyle?: any
  headerTextStyle?: any
}

const List = ({
  type = 'DEFAULT',
  data,
  numOfColumns,
  sizeConfig,
  headTitle,
  keyExtractor,
  onPress = () => {},
  onAction,
  listTitle,
  onSearch,
  filterData,
  expandView,
  isExpanded = false,
  showExpandArrow = false,
  expandedIndex = -1,
  showSyncPam = false,
  onSync,
  onEdit,
  onDelete,
  hrefPath,
  isColumnSearchEnabled,
  onSearchTextChange,
  isActionLoading,
  loadingIndex,
  hidePagination = false,
  exportFile,
  getFilteredData,
  onChecked,
  onAllChecked,
  isAllChecked = false,
  pageSizeFromApi = 10,
  updateSortKeys,
  sortOrder,
  columnsWidth,
  tableWidth,
  hideTitle = false,
  renderItem,
  cellTextStyle,
  headerTextStyle,
}: ListProps) => {
  if (type !== 'SCROLLABLE' && numOfColumns !== sizeConfig?.length) {
    throw new Error('sizeConfig array length must be equal to the numOfColumns.')
  }
  if (type !== 'SCROLLABLE' && numOfColumns !== headTitle?.length) {
    throw new Error('headTitle array length must be equal to the numOfColumns.')
  }
  if (type !== 'SCROLLABLE' && headTitle?.length !== sizeConfig?.length) {
    throw new Error('sizeConfig array length must be equal to the headTitle array length.')
  }

  const [dataWindow, setDataWindow] = useState(pageSizeFromApi)
  const [totalPages, setTotalPages] = useState(Math.ceil(data?.length / dataWindow))
  const [start, setStart] = useState(0)
  const [end, setEnd] = useState(dataWindow)
  const [pageNumber, setPageNumber] = useState(0)

  const [listData, setListData] = useState<any[]>([])
  const [allData, setAllData] = useState<any[]>([])
  const [sortData, setSortData] = useState({ order: 'asc', key: '' })
  const [sortArr, setSortArr] = useState<any[]>([])
  const [searchColumnkeys, setSearchColumnKeys] = useState<any>([])
  const [searchColumnListData, setSearchColumnListData] = useState<any[]>([])

  useEffect(() => {
    const list = searchColumnkeys?.length > 0 ? searchColumnListData : data
    setTotalPages(Math.ceil(list?.length / dataWindow))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchColumnListData])

  const onSort = (key: any, sortOrder?: any) => {
    let comparision = 1
    const selectedHeadTitleOrder =
      sortArr?.filter((item) => {
        return item?.key?.toLowerCase()?.replace(' ', '') === key?.toLowerCase()?.replace(' ', '')
      })?.[0]?.order ?? sortOrder
    const dataArr = searchColumnkeys?.length > 0 ? searchColumnListData : allData?.length > 0 ? allData : data
    const sorted = dataArr.sort((a, b) => {
      const x = a[key]
      const y = b[key]
      if (isNaN(x)) {
        comparision = x < y ? 1 : -1
      } else {
        comparision = +x < +y ? 1 : -1
      }
      return selectedHeadTitleOrder === 'desc' ? comparision : comparision * -1
    })
    const order = sortData.order === 'asc' ? 'desc' : 'asc'
    setSortData({ order: order, key: key })
    if (searchColumnkeys?.length > 0) {
      setSearchColumnListData(sorted)
    } else {
      setAllData(sorted)
      setListData(sorted?.slice(start, end))
    }
    const sortedArr = sortArr.map((item) => {
      if (item.key.toLowerCase().replace(' ', '') === key.toLowerCase().replace(' ', '')) {
        return {
          ...item,
          order: item.order === 'asc' ? 'desc' : 'asc',
        }
      } else {
        return item
      }
    })
    setSortArr(sortedArr)
  }

  const _renderItem = (data: any) => (
    <ListRow
      onPress={() => onPress(data.item, data.index)}
      item={data.item}
      headTitle={headTitle}
      index={data.index}
      sizeConfig={sizeConfig}
      onAction={() => onAction && onAction(data.item, data.index)}
      expandView={expandView}
      isExpanded={isExpanded}
      expandedIndex={expandedIndex}
      showExpandArrow={showExpandArrow}
      onEdit={() => onEdit && onEdit(data)}
      onDelete={() => onDelete && onDelete(data)}
      hrefPath={hrefPath}
      isActionLoading={isActionLoading}
      loadingIndex={loadingIndex}
      type={type}
      onChecked={onChecked}
      columnsWidth={columnsWidth}
      cellTextStyle={cellTextStyle}
    />
  )

  useEffect(() => {
    const list = searchColumnkeys?.length > 0 ? searchColumnListData : data
    setListData(list?.slice(start, end))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start, end])

  useEffect(() => {
    if (sortData.key !== '') {
      const list = searchColumnkeys?.length > 0 ? searchColumnListData : data
      setAllData(list)
      setListData(list?.slice(start, end))
    } else {
      const localSortData = localStorage.getItem('sortingOrder')
      const sortOrderFromLocalStorage = localSortData && JSON.parse(localSortData)
      setSortData(
        sortOrderFromLocalStorage?.title === listTitle
          ? { order: sortOrderFromLocalStorage?.order, key: sortOrderFromLocalStorage?.key }
          : { order: 'asc', key: '' },
      )
      if (sortOrderFromLocalStorage && listTitle && sortOrderFromLocalStorage?.title === listTitle) {
        const sortOrder = JSON.parse(localSortData)
        if (sortOrder.title === listTitle) {
          onSort(sortOrder.key, sortOrderFromLocalStorage?.order)
        }
      } else {
        setListData(data?.slice(start, end))
        setAllData(data)
        const arr: any = []
        headTitle?.map((item: any, index: number) => {
          arr.push({ order: 'asc', index: index, key: item[Object.keys(item)[0]] })
        })
        setSortArr(arr)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const handleColumnSearch = (label: string, searchString: string) => {
    setPageNumber(0)
    setStart(0)
    setEnd(dataWindow)
    // localStorage.setItem('sortingOrder', JSON.stringify({ key: label, order: sortData?.order }))
    let keysArray: any = []
    const getData = () => {
      return searchColumnkeys?.map((item) => {
        return {
          key: item?.key,
          searchString: item?.key === label ? searchString : item.searchString,
        }
      })
    }
    if (searchString?.length > 0) {
      keysArray =
        searchColumnkeys?.filter((item: any) => item?.key === label)?.length > 0
          ? getData()
          : [...searchColumnkeys, { key: label, searchString }]
      setSearchColumnKeys(keysArray)
    } else {
      keysArray = searchColumnkeys?.filter((item: any) => item?.key !== label) ?? []
      setSearchColumnKeys(keysArray)
    }
    if (keysArray?.length > 0) {
      const filteredList = getFilteredData(allData, keysArray, searchString)
      setListData(filteredList?.slice(start, end))
      setSearchColumnListData(filteredList)
    } else {
      const filteredList = getFilteredData(allData)
      setListData(filteredList?.slice(start, end))
      setSearchColumnListData(filteredList)
    }
  }

  const handleOnSort = (key: any) => {
    onSort(key, sortData.order)
    const sortingData = { title: listTitle, key: key, order: sortData.order }
    const sortedArr = sortArr.map((item) => {
      if (item.key.toLowerCase().replace(' ', '') === key.toLowerCase().replace(' ', '')) {
        return {
          ...item,
          order: item.order === 'asc' ? 'desc' : 'asc',
        }
      } else {
        return item
      }
    })
    setSortArr(sortedArr)
    localStorage.setItem('sortingOrder', JSON.stringify(sortingData))
  }
  return (
    <Box>
      {!isEmpty(listTitle) && (
        <Box {...styles[type].container} bg={'#f8f9fc' as ColorOptions}>
          <Text
            fontFamily="jiotype-bold"
            color={'#214796' as ColorOptions}
            fontSize={16}
            title={listTitle}
            hide={hideTitle}
          />
          <Box flexDirection={'row'} align={'center'} gap={16}>
            <ButtonNew
              title={'Sync PAM'}
              onPress={() => onSync && onSync()}
              height={30}
              color={'GREEN'}
              hide={!showSyncPam}
              borderRadius={4}
            />
            <ButtonNew
              title={'Export To Excel'}
              onPress={() => exportFile && exportFile(searchColumnkeys?.length > 0 ? searchColumnListData : data)}
              height={32}
              borderRadius={4}
              hide={
                listTitle !== 'Merchant Mapping Approvals' &&
                listTitle !== 'Merchant Mapping List' &&
                listTitle !== 'Dynamic Hold Settlements' &&
                listTitle !== 'Risk Controls - Transactions - Approvals' &&
                listTitle !== 'Risk Controls - MID - Approvals' &&
                listTitle !== 'Payout CMS - Approvals' &&
                listTitle !== 'Credit Debit Adjustment Approvals' &&
                listTitle !== 'Merchant payout Config Approvals' &&
                listTitle !== 'Merchant Id to Package Approvals'
              }
              disabled={allData?.length < 1}
              hoverColor={'DARK_OCEAN_BLUE'}
            />
          </Box>
        </Box>
      )}
      <Box {...styles[type].listContainer}>
        {onSearch && filterData && (
          <Box alignSelf="flex-end">
            <SearchFilter onSearch={onSearch} isFilter filterData={filterData} />
          </Box>
        )}
        <Box overflowX={'scroll'}>
          <Box width={tableWidth}>
            <ListHead
              headTitle={headTitle}
              sizeConfig={sizeConfig}
              onSort={updateSortKeys ? updateSortKeys : handleOnSort}
              sortData={sortArr}
              showExpandArrow={showExpandArrow}
              isColumnSearchEnabled={isColumnSearchEnabled}
              onSearchTextChange={handleColumnSearch}
              type={type}
              onAllChecked={onAllChecked}
              isAllChecked={isAllChecked}
              apiSortOrder={sortOrder}
              columnsWidth={columnsWidth}
              headerTextStyle={headerTextStyle}
            />
            <FlatList
              keyExtractor={keyExtractor}
              data={searchColumnkeys?.length > 0 ? searchColumnListData?.slice(start, end) : listData}
              renderItem={renderItem ?? _renderItem}
            />
          </Box>
        </Box>
        {listData?.length === 0 && (
          <Box pt={16}>
            <TextNew textAlign="center" fontFamily="jiotype-medium" color={'BLACK_21'}>
              {'No Records Found'}
            </TextNew>
          </Box>
        )}
        <ModBox show={!hidePagination}>
          <Pagination
            dataWindow={dataWindow}
            setDataWindow={setDataWindow}
            onPageClick={(pageNumber: number) => {
              setPageNumber(pageNumber)
              setStart(pageNumber * dataWindow)
              setEnd(pageNumber * dataWindow + dataWindow)
            }}
            onItemsCountSelect={(count: string) => {
              setDataWindow(parseInt(count))
              setTotalPages(
                Math.ceil(
                  (searchColumnkeys?.length > 0 ? searchColumnListData?.length : data?.length) / parseInt(count),
                ),
              )
              setStart(0)
              setEnd(parseInt(count))
              setPageNumber(0)
            }}
            pageNumber={pageNumber}
            totalPages={totalPages}
            total={searchColumnkeys?.length > 0 ? searchColumnListData?.length : data?.length}
          />
        </ModBox>
      </Box>
    </Box>
  )
}

export { List }
